import 'dayjs/locale/vi';

import dayjs from 'dayjs';

import { viVN } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// custom locale text
const customLocaleText = {
  ...viVN.components.MuiLocalizationProvider.defaultProps.localeText,
  cancelButtonLabel: 'Hủy',
  okButtonLabel: 'Xong',
  todayButtonLabel: 'Hôm nay',
  previousMonthButtonLabel: 'Tháng trước',
  nextMonthButtonLabel: 'Tháng sau',
};

// ----------------------------------------------------------------------

type DateOnlyPickerProps = Omit<DatePickerProps<dayjs.Dayjs>, 'value' | 'onChange'> & {
  value: string; // ISO date string YYYY-MM-DD
  onChange: (value: string) => void;
  label?: string;
};

export function DateOnlyPicker({ value, onChange, label, ...other }: DateOnlyPickerProps) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="vi"
      localeText={customLocaleText}
    >
      <DatePicker
        sx={{
          '& .MuiPickersCalendarHeader-labelContainer': {
            textTransform: 'capitalize',
          },
        }}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          onChange(newValue ? newValue.format('YYYY-MM-DD') : '');
        }}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            size: 'small',
          },
          calendarHeader: {
            sx: {
              '& .MuiPickersCalendarHeader-label': {
                textTransform: 'capitalize',
              },
            },
          },
        }}
        label={label}
        {...other}
      />
    </LocalizationProvider>
  );
}
